/**
 * @class EventSignpostingIconsTypes
 * @name types
 * @memberof Mojito.Presentation.Components.EventSignpostingIcons
 */

export default class EventSignpostingIconsTypes {}

/**
 * Types of icons shown in EventSignpostingIcons component.
 *
 * @readonly
 * @enum {string}
 * @memberof Mojito.Presentation.Components.EventSignpostingIcons.types
 */
EventSignpostingIconsTypes.ICONS = {
    /** Bet Builder icon type. */
    BET_BUILDER: 'BET_BUILDER',
    /** Price Boost icon type. */
    PRICE_BOOST: 'PRICE_BOOST',
    /** Streaming icon type. */
    STREAMING: 'STREAMING',
    /** Neutral Venue icon type. */
    NEUTRAL_VENUE: 'NEUTRAL_VENUE',
};
